import {NewsBookmarksError} from './NewsBookmarksError.js'

export class GetSavedNewsIdsError extends NewsBookmarksError {
  constructor(message) {
    super(message)
    this.name = 'GetSavedNewsIdsError'
  }

  static create(message) {
    return new GetSavedNewsIdsError(message)
  }
}
